const normalizeRole = (role) => {
  const resolved = String(role || "").trim().toLowerCase();
  if (resolved === "owner") return "admin";
  if (["admin", "manager", "viewer"].includes(resolved)) return resolved;
  return "viewer";
};

export const isAdmin = (role) => normalizeRole(role) === "admin";

export const isViewer = (role) => normalizeRole(role) === "viewer";

export const isManager = (role) => normalizeRole(role) === "manager";
